export class LimitedLengthArray<T> {
    private _items: T[];
    private _maxLength: number;

    constructor(maxLength: number) {
      if (maxLength <= 0) {
        throw new Error("Maximum length must be greater than 0");
      }
      this._maxLength = maxLength;
      this._items = [];
    }

    push(item: T): void {
      if (this._items.length === this._maxLength) {
        this._items.shift();
      }
      this._items.push(item);
    }

    pop(): T | undefined {
      return this._items.pop();
    }

    get length(): number {
      return this._items.length;
    }

    get(index: number): T | undefined {
      return this._items[index];
    }

    getAll(): T[] {
      return [...this._items]; // Return a copy to prevent external modification
    }
  }
